import React from 'react'
import {useHistory} from 'react-router-dom'
import {css} from '@emotion/core'
import styled from '@emotion/styled'

import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'
import ArrowLink from '../ArrowButton'

const REFERRAL_PROGRAM_URL = '/user/membership/referral'

const RowWrapper = styled('div')(
  ({theme}) => css`
    padding: ${theme.layout.spacing.s600}px 0;
    border-bottom: solid 1px ${theme.colors.navMenuBorder};
  `
)

export const InviteFriendsToPlus = () => {
  const history = useHistory()
  const goToReferralProgramPage = () => history.push(REFERRAL_PROGRAM_URL)

  return (
    <RowWrapper>
      <ArrowLink onClick={goToReferralProgramPage}>
        <FormattedMessageWrapper
          id="preferenceSelector.inviteFriendsToPlus"
          defaultMessage="Invite Friends to Plus"
        />
      </ArrowLink>
    </RowWrapper>
  )
}
